export const menuText = {
    password: {
        'en': 'Set password',
        'fr': 'Configurez le mot de passe',
        'de': 'Passwort festlegen',
        'ko': '비밀번호 설정',
        'ch': '设置密码',
        'ru': 'Установить пароль',
        'it': 'Imposta password',
        'jap': 'パスワードを設定',
        'port': 'Configurar senha',
        'turk': 'Şifre belirle',
        'viet': 'Đặt mặt khẩu',
        'spa': 'Establecer contraseña',
        'arab': 'حدد كلمة السر'
    },
    website: {
        'en': 'WEBSITE',
        'fr': 'SITE',
        'de': 'WEBSITE',
        'ko': '웹사이트',
        'ch': '网站',
        'ru': 'САЙТ',
        'it': 'SITO WEB',
        'jap': 'Webサイト',
        'port': 'SITE',
        'turk': 'İNTERNET SİTESİ',
        'viet': 'TRANG WEB',
        'spa': 'SITIO WEB',
        'arab': 'موقع الكتروني'
    },
    dashboard: {
        'en': 'DASHBOARD',
        'fr': 'TABLEAU DE BORD',
        'de': 'DASHBOARD',
        'ko': '대시보드',
        'ch': '控制面板',
        'ru': 'ОСНОВНОЕ',
        'it': 'PANNELLO',
        'jap': 'ダッシュボード',
        'port': 'PAINEL',
        'turk': 'PANO',
        'viet': 'BẢNG ĐIỀU KHIỂN',
        'spa': 'DASHBOARD',
        'arab': 'لوحة القيادة'
    },
    profile: {
        'en': 'PROFILE',
        'fr': 'PROFIL',
        'de': 'PROFIL',
        'ko': '프로필',
        'ch': '个人资料',
        'ru': 'ПРОФИЛЬ',
        'it': 'PROFILO',
        'jap': 'プロフィール',
        'port': 'PERFIL',
        'turk': 'PROFİL',
        'viet': 'HỒ SƠ',
        'spa': 'PERFIL',
        'arab': 'الملف الشخصي'
    },
    referral: {
        'en': 'REFERRAL',
        'fr': 'PARRAINAGE',
        'de': 'EMPFEHLUNG',
        'ko': '추천',
        'ch': '推荐',
        'ru': 'РЕФЕРАЛ',
        'it': 'RIFERIMENTO',
        'jap': '紹介',
        'port': 'REFERÊNCIA',
        'turk': 'TAVSİYE',
        'viet': 'GIỚI THIỆU',
        'spa': 'REFERIDO',
        'arab': 'الإحالة'
    },
    payments: {
        'en': 'PAYMENTS',
        'fr': 'PAIEMENTS',
        'de': 'ZAHLUNGEN',
        'ko': '결제',
        'ch': '付款',
        'ru': 'ПЛАТЕЖИ',
        'it': 'PAGAMENTI',
        'jap': '決済',
        'port': 'PAGAMENTOS',
        'turk': 'ÖDEMELER',
        'viet': 'THANH TOÁN',
        'spa': 'PAGOS',
        'arab': 'المدفوعات'
    },
    staking: {
        'en': 'STAKING',
        'fr': 'STAKING',
        'de': 'STAKING',
        'ko': '스테이킹',
        'ch': '质押',
        'ru': 'СТЕЙКИНГ',
        'it': 'STAKING',
        'jap': '賭け',
        'port': 'STAKING',
        'turk': 'HİSSE ALIMI',
        'viet': 'STAKE',
        'spa': 'STAKING',
        'arab': 'التخزين'
    },
    news: {
        'en': 'NEWS',
        'fr': 'ACTUALITÉS',
        'de': 'NEWS',
        'ko': '소식',
        'ch': '新闻',
        'ru': 'НОВОСТИ',
        'it': 'NOVITÀ',
        'jap': 'ニュース',
        'port': 'NOTÍCIAS',
        'turk': 'HABERLER',
        'viet': 'TIN TỨC',
        'spa': 'NOTICIAS',
        'arab': 'الإخبار'
    },
    faq: {
        'en': 'FAQ',
        'fr': 'FAQ',
        'de': 'FAQ',
        'ko': 'FAQ',
        'ch': 'FAQ',
        'ru': 'FAQ',
        'it': 'FAQ',
        'jap': 'FAQ',
        'port': 'FAQ',
        'turk': 'FAQ',
        'viet': 'FAQ',
        'spa': 'FAQ',
        'arab': 'FAQ'
    },
    support: {
        'en': 'SUPPORT',
        'fr': 'ASSISTANCE',
        'de': 'SUPPORT',
        'ko': '지원',
        'ch': '支持',
        'ru': 'ПОДДЕРЖКА',
        'it': 'AIUTO',
        'jap': 'サポート',
        'port': 'SUPORTE',
        'turk': 'DESTEK',
        'viet': 'HỖ TRỢ',
        'spa': 'SOPORTE',
        'arab': 'الدعم'
    },
    logout: {
        'en': 'LOGOUT',
        'fr': 'DÉCONNEXION',
        'de': 'ABMELDEN',
        'ko': '로그아웃',
        'ch': '退出',
        'ru': 'ВЫЙТИ',
        'it': 'LOGOUT',
        'jap': 'ログアウト',
        'port': 'SAIR',
        'turk': 'ÇIKIŞ YAP',
        'viet': 'ĐĂNG XUẤT',
        'spa': 'CERRAR SESIÓN',
        'arab': 'تسجيل خروج'
    },
    pass_text1: {
        'en': 'Enter your password for access',
        'fr': 'Saisissez votre mot de passe daccès',
        'de': 'Geben Sie Ihr Passwort für den Zugriff ein',
        'ko': '액세스하려면 비밀번호를 입력하십시오',
        'ch': '输入您的访问密码',
        'ru': 'Введите свой пароль для входа',
        'it': 'Inserisci la tua password per accedere',
        'jap': 'アクセス用のパスワードを入力してください',
        'port': 'Digite sua senha para acesso',
        'turk': 'Erişim şifrenizi giriniz',
        'viet': 'Nhập mật khẩu để truy cập',
        'spa': 'Introduce tu contraseña para acceder',
        'arab': 'أدخل كلمة السرالخاصة بك للوصول'
    },
    decline: {
        'en': 'Decline',
        'fr': 'Refuser',
        'de': 'Ablehnen',
        'ko': '거부',
        'ch': '拒绝',
        'ru': 'Отклонить',
        'it': 'Rifiuta',
        'jap': '拒否',
        'port': 'Rejeitar',
        'turk': 'Reddet',
        'viet': 'Từ chối',
        'spa': 'Rechazar',
        'arab': 'رفض'
    },
    accept: {
        'en': 'Accept',
        'fr': 'Accepter',
        'de': 'Akzeptieren',
        'ko': '수락',
        'ch': '接受',
        'ru': 'Принять',
        'it': 'Accetta',
        'jap': '受諾',
        'port': 'Aceitar',
        'turk': 'Kabul Et',
        'viet': 'Chấp nhận',
        'spa': 'Aceptar',
        'arab': 'قبول'
    },
    old_pass: {
        'en': 'Old password',
        'fr': 'Ancien mot de passe',
        'de': 'Altes Passwort',
        'ko': '기존 비밀번호',
        'ch': '旧密码',
        'ru': 'Старый пароль',
        'it': 'Vecchia password',
        'jap': '古いパスワード',
        'port': 'Senha antiga',
        'turk': 'Eski şifre',
        'viet': 'Mật khẩu cũ',
        'spa': 'Contraseña antigua',
        'arab': 'كلمة السر القديمة'
    },
    new_pass: {
        'en': 'New password',
        'fr': 'Nouveau mot de passe',
        'de': 'Neues Passwort',
        'ko': '새 비밀번호',
        'ch': '新密码',
        'ru': 'Новый пароль',
        'it': 'Nuova password ',
        'jap': '新しいパスワード',
        'port': 'Nova senha ',
        'turk': 'Yeni şifre ',
        'viet': 'Mật khẩu mới ',
        'spa': 'Nueva contraseña ',
        'arab': 'كلمة السر الجديدة '
    },
    confirm_pass: {
        'en': 'Confirm new password',
        'fr': 'Confirmer le nouveau mot de passe',
        'de': 'Neues Passwort bestätigen',
        'ko': '새 비밀번호 확인',
        'ch': '确认新密码',
        'ru': 'Подтвердите новый пароль',
        'it': 'Conferma la nuova password',
        'jap': '新しいパスワードを確認',
        'port': 'Confirme a nova senha',
        'turk': 'Yeni şifreyi doğrula',
        'viet': 'Xác nhận mật khẩu mới',
        'spa': 'Confirmar la nueva contraseña',
        'arab': 'تأكيد كلمة السر الجديدة'
    },
    match_pass: {
        'en': 'passwords match',
        'fr': 'les mots de passe correspondent',
        'de': 'Passwörter stimmen überein',
        'ko': '비밀번호 일치',
        'ch': '密码一致',
        'ru': 'пароли совпадают',
        'it': 'corrispondenza password',
        'jap': 'パスワードが一致しました',
        'port': 'Senhas correspondem',
        'turk': 'şifreler eşleşti',
        'viet': 'mật khẩu trùng khớp',
        'spa': 'las contraseñas coinciden',
        'arab': 'كلمات السر متطابقة'
    },
    metaverse: {
        'en': 'Launchpad',
        'fr': 'Launchpad',
        'de': 'Launchpad',
        'ko': 'Launchpad',
        'ch': 'Launchpad',
        'ru': 'Launchpad',
        'it': 'Launchpad',
        'jap': 'Launchpad',
        'port': 'Launchpad',
        'turk': 'Launchpad',
        'viet': 'Launchpad',
        'spa': 'Launchpad',
        'arab': 'Launchpad'
    },
    faq_title: {
        'en': '$ARTY Token FAQ',
        'fr': 'FAQ relative au jeton $ARTY',
        'de': '$ARTY-Token-FAQ',
        'ko': '$ARTY 토큰 FAQ',
        'ch': '$ARTY 代币常见问题解答',
        'ru': 'Часто задаваемые вопросы о токене $ARTY',
        'it': 'Token $ARTY FAQ',
        'jap': '$ARTYトークンに関するよくある質問',
        'port': 'Perguntas frequentes de token $ARTY ',
        'turk': '$ARTY Token SSS',
        'viet': 'Câu hỏi thường gặp về token ARTY$',
        'spa': 'Preguntas frecuentes sobre los tokens $ARTY',
        'arab': 'الأسئلة الشائعة حول ARTY$'
    },
    support_center: {
        'en': 'Artyfact Support Center',
        'fr': 'Centre dassistance dArtyfact',
        'de': 'Artyfact-Support-Center',
        'ko': 'Artyfact 지원 센터',
        'ch': 'Artyfact 支持中心',
        'ru': 'Центр Поддержки Artyfact',
        'it': 'Centro di Supporto Artyfact',
        'jap': 'Artyfactサポートセンター',
        'port': 'Centro de suporte de Artyfact ',
        'turk': 'Artyfact Destek Merkezi',
        'viet': 'Trung tâm hỗ trợ Artyfact',
        'spa': 'Centro de soporte de Artyfact',
        'arab': 'مركز دعم أرتيفاكت'
    },
    verified: {
        'en': 'Verified',
        'fr': 'Vérifiée',
        'de': 'Bestätigt',
        'ko': '확인됨',
        'ch': '已验证',
        'ru': 'Верифицирован',
        'it': 'Verificato',
        'jap': '確認済み',
        'port': 'Verificado',
        'turk': 'Doğrulanmış',
        'viet': 'Đã xác minh',
        'spa': 'Verificado',
        'arab': 'تم التحقق'
    },
    not_verified: {
        'en': 'Not verified',
        'fr': 'Non vérifié',
        'de': 'Nicht überprüft',
        'ko': '확인되지 않음',
        'ch': '未验证',
        'ru': 'Не верифицирован',
        'it': 'Non verificato',
        'jap': '未確認',
        'port': 'Não verificado',
        'turk': 'Doğrulanmamış',
        'viet': 'Chưa được xác thực',
        'spa': 'Sin verificar',
        'arab': 'لم يتم التحقق منها'
    },
};